import React, { useState } from 'react';
import { ChromePicker } from 'react-color';
import { MdOutlineColorize } from 'react-icons/md';

const ColorPicker = ({ 
  label, 
  value, 
  onChange, 
  showEyeDropper = true 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  
  // EyeDropper API desteğini kontrol et
  const isEyeDropperSupported = 'EyeDropper' in window;
  
  // EyeDropper ile ekrandan renk seç
  const pickColorFromScreen = async () => {
    if (!isEyeDropperSupported) {
      alert('EyeDropper API bu tarayıcıda desteklenmiyor.');
      return;
    }
    
    try {
      const eyeDropper = new window.EyeDropper();
      const result = await eyeDropper.open();
      onChange(result.sRGBHex);
    } catch (error) {
      console.log('Renk seçimi iptal edildi veya bir hata oluştu:', error);
    }
  };

  return (
    <div className="color-setting">
      <div className="color-label">
        <span>{label}:</span>
        <div className="color-actions">
          {showEyeDropper && isEyeDropperSupported && (
            <button 
              className="eyedropper-button"
              onClick={pickColorFromScreen}
              title="Ekrandan renk seç"
            >
              <MdOutlineColorize size={18} />
            </button>
          )}
          <div 
            className="color-preview"
            style={{ backgroundColor: value }}
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
      </div>
      
      {isOpen && (
        <div className="color-picker-container">
          <ChromePicker 
            color={value}
            onChange={(color) => onChange(color.hex)}
            disableAlpha={false}
          />
        </div>
      )}
    </div>
  );
};

export default ColorPicker; 